/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'requirement-ok': {
    width: 26,
    height: 26,
    viewBox: '0 0 26 26',
    data: '<defs><path pid="0" id="svgicon_requirement-ok_a" d="M4.057 9.19l7.711-7.59L12.8 2.613 4.057 11.2 0 7.216l1.014-1.013z"/></defs><g stroke-width="3" _fill="none" fill-rule="evenodd"><circle pid="1" _fill="currentcolor" cx="12.8" cy="12.8" r="12.8"/><g transform="translate(6.4 7.2)"><mask id="svgicon_requirement-ok_b" _fill="#fff"><use xlink:href="#svgicon_requirement-ok_a"/></mask><use _fill="#000" fill-rule="nonzero" xlink:href="#svgicon_requirement-ok_a"/><g mask="url(#svgicon_requirement-ok_b)" _fill="#FFF"><path pid="2" d="M0 0h12.8v12.8H0z"/></g></g></g>'
  }
})
